import WishlistIcon from "./WishlistIcon";

export default WishlistIcon;
